/* Verolae · Reviews List — "Read More Reviews" toggle.
   Ported from the inline <script> of the source site "ceylon_reviews_list" section:
   - collapsed → expand every card (add .show-review, drop .mobile-hidden / .desktop-hidden) and
     switch the label to the "expanded" label;
   - expanded → re-hide the cards past the mobile / desktop limits, restore the "collapsed" label
     and scroll the list back to its start.
   Each section instance is scoped by its root element; the labels and the two limits come from
   data attributes so the theme editor controls them. No dependencies, no analytics. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.verolae-reviews-list[data-section-id]';

  function setup(root) {
    if (!root || root.getAttribute('data-rl-ready') === 'true') return;

    var wrapper = root.querySelector('.reviews-list-wrapper');
    if (!wrapper) return;

    var toggleBtn = wrapper.querySelector('.reviews-list-toggle-btn');
    var container = wrapper.querySelector('.reviews-cards-container');
    if (!toggleBtn || !container) return;

    var visibleMobile = parseInt(root.getAttribute('data-visible-mobile'), 10);
    var visibleDesktop = parseInt(root.getAttribute('data-visible-desktop'), 10);
    if (isNaN(visibleMobile)) visibleMobile = 2;
    if (isNaN(visibleDesktop)) visibleDesktop = 4;

    var readMore = root.getAttribute('data-read-more') || toggleBtn.textContent.trim();
    var readLess = root.getAttribute('data-read-less') || readMore;

    function cards() {
      return container.querySelectorAll('.review-card-item');
    }

    function expand() {
      // Expand all
      cards().forEach(function (card) {
        card.classList.add('show-review');
        card.classList.remove('mobile-hidden', 'desktop-hidden');
      });
      toggleBtn.textContent = readLess;
      toggleBtn.setAttribute('data-state', 'expanded');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    function collapse() {
      cards().forEach(function (card, idx) {
        card.classList.remove('show-review');
        if (idx >= visibleMobile) {
          card.classList.add('mobile-hidden');
        }
        if (idx >= visibleDesktop) {
          card.classList.add('desktop-hidden');
        }
      });
      toggleBtn.textContent = readMore;
      toggleBtn.setAttribute('data-state', 'collapsed');
      toggleBtn.setAttribute('aria-expanded', 'false');

      // Scroll back up to container start smoothly
      container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    toggleBtn.onclick = function () {
      if (toggleBtn.getAttribute('data-state') === 'collapsed') {
        expand();
      } else {
        collapse();
      }
    };

    root.verolaeReviewsList = { expand: expand, collapse: collapse };
    root.setAttribute('data-rl-ready', 'true');
  }

  function initAll(scope) {
    var base = scope && scope.querySelectorAll ? scope : document;
    if (base !== document && base.matches && base.matches(ROOT_SELECTOR)) {
      setup(base);
    }
    var roots = base.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      setup(roots[i]);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  // Theme editor: re-initialise a re-rendered section instance.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Theme editor: when the merchant selects a review block that is currently collapsed away,
  // expand the list so the selected card is visible.
  document.addEventListener('shopify:block:select', function (e) {
    var target = e.target;
    var root = target && target.closest ? target.closest(ROOT_SELECTOR) : null;
    if (!root) return;
    if (!root.verolaeReviewsList) setup(root);
    if (
      root.verolaeReviewsList &&
      target.classList &&
      (target.classList.contains('mobile-hidden') || target.classList.contains('desktop-hidden'))
    ) {
      root.verolaeReviewsList.expand();
    }
  });

  initAll(document);
})();
